import React from "react";
import { TableCell, TableRow, Typography } from "@mui/material";
import { Result } from "../../interfaces/ICompetitions";

interface EliminationResultRowProps {
  result: Result;
}

export default function EliminationResultRow({ result }: EliminationResultRowProps) {
  return (
    <TableRow>
      <TableCell
        sx={{
          fontSize: { xs: "0.875rem", sm: "0.9375rem" },
          width: "60px",
          paddingLeft: { xs: 1, sm: 1.5 },
          paddingRight: { xs: 1, sm: 1.5 },
        }}
        align="center"
      >
        {result.presentation.id}
      </TableCell>
      <TableCell
        align="center"
        sx={{
          fontSize: { xs: "0.875rem", sm: "0.9375rem" },
          width: "60px",
          paddingLeft: { xs: 0.5, sm: 1 },
          paddingRight: { xs: 0.5, sm: 1 },
        }}
      >
        {result.promotion ? (
          <Typography
            component="span"
            sx={{
              color: "success.main",
              fontWeight: 600,
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
            }}
          >
            ✓
          </Typography>
        ) : (
          <Typography
            component="span"
            sx={{
              color: "text.secondary",
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
            }}
          >
            -
          </Typography>
        )}
      </TableCell>
      <TableCell sx={{ fontSize: { xs: "0.875rem", sm: "0.9375rem" } }} align="left">
        {result.presentation.name}
      </TableCell>
    </TableRow>
  );
}

